export const setPassword = {
  old_passwd: "sysOldPasswd",
  new_passwd: "sysNewPasswd",
  confirm_passwd: "sysConfirmPasswd",
};

export default setPassword;
